import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import styled from "@emotion/styled";
import NotePage from "@pages/Notes/NotePage";
import SequencePage from "@pages/Sequence/SequencePage";
import { useLocation, useNavigate } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}


interface ClientTabsProps{
  tabIndex?: number
}
export default function ClientTabs({tabIndex}: ClientTabsProps) {
  const location = useLocation();
  const navigate = useNavigate()

  const [value, setValue] = React.useState(Number(tabIndex ?? '0'));

  React.useEffect(()=>{
    if(location.pathname.includes('notes')){
      setValue(0)
    }
    if(location.pathname.includes('sequences')){
      setValue(1)
    }
  }, [location.pathname])

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if(value == newValue) return

      let url = `/notes`
      if(newValue == 1){
        url = `/sequences`
      }
      navigate(url, {replace: true})
  };
  const StyledBox = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 24px;
  `;

  const StyledTabs = styled(Tabs)`
    & .MuiTab-root {
      text-transform: none;
      font-family: Nunito;
      font-size: 16px;
      font-weight: 500;
    }
    & .Mui-selected {
      font-weight: 700;
    }
  `;

  return (
    <StyledBox sx={{ width: "100%" }}>
      <Box sx={{}}>
        <StyledTabs
          id='asdf'
          value={value}
          onChange={handleChange}
          aria-label='basic tabs example'
        >
          <Tab label='Notes' {...a11yProps(0)} />
          <Tab label='Sequences' {...a11yProps(1)} />
        </StyledTabs>
      </Box>
      <TabPanel value={value} index={0}>
        <NotePage pagefor={'client'}/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <SequencePage pagefor={'client'}/>
      </TabPanel>
    </StyledBox>
  );
}
